/**
 * Shared helpers for schemas deriving their wire shape from the generated Zod.
 * Domains import from here rather than redefining them. See ./README.md.
 */
import { z } from 'zod';

import { emptyStringToNull, VALID_DATE_YEAR_MESSAGE, validateDateYear } from './zodHelpers';

/** Wire sends a decimal as a STRING; the UI does math on it, so adopt a number. */
export const decimalNumber = z.coerce.number();

/**
 * Nullable decimal adopted as a number. `emptyStringToNull` guards the `'' → 0`
 * trap: `Number('') === 0` would turn an unset money field into `$0.00`.
 */
export const decimalNumberNullable = emptyStringToNull(z.coerce.number().nullable());

/**
 * Nullable date keeping the 1900–2100 refinement but NOT the generated `.date()`
 * check, which is stricter than what the app accepts. `null` and `''` pass.
 */
export const nullableRefinedDate = z
  .string()
  .nullable()
  .refine((value) => value == null || validateDateYear(value), {
    message: VALID_DATE_YEAR_MESSAGE,
  });
